import BookingOverview from "../tabs/BookingOverview"
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import { strings } from '../strings'
import { constants } from '../constants'
import '../styling/tabs.css'

const Admin = () => {

    return (
        <div className='admin'>

            <Tabs>
                <TabList>
                    <Tab>{strings.admin.laundryTitle}</Tab>
                    <Tab>{strings.admin.balconyTitle}</Tab>
                </TabList>

                <TabPanel>
                    <BookingOverview type={constants.laundryType} />
                </TabPanel>

                <TabPanel>
                    <BookingOverview type={constants.balconyType} />
                </TabPanel>

            </Tabs>
        </div>
    )
}

export default Admin